import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { useEffect } from "react";

const enum fields {
   scriptUrl = "scriptUrl",
}

interface Props extends WidgetProps {
    fields: {
        [fields.scriptUrl]: string;
    };
}

export const ChatHubSpot: React.FunctionComponent<Props> = props => {
    const userContext = props?.fields?.scriptUrl;
    useEffect(() => {
          const script = document.createElement("script");
          script.src = userContext;
          script.async = true;
          document.body.appendChild(script);
          return () => {
            // Cleanup function to remove the script when component unmounts
          document.body.removeChild(script);
        };
    }, []); 

    return (
         <div>
            <div id="scriptTarget" />
            <div className="main">
               {/* Other stuff */}
            </div>
    </div>
    )
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const widgetModule: WidgetModule = {
    component: ChatHubSpot,
    definition: {
        group: "Basic",
        icon: "text",
        fieldDefinitions: [
             {
                fieldType: "General",
                name: fields.scriptUrl,
                editorTemplate: "TextField",
                displayName: "ChatBot Script",
                defaultValue: "",
                tab: basicTab,
                validate: (value: string) => {
                    // Regular expression to validate script URL format
                    const scriptUrlPattern = /^\/\/js\.hs-scripts\.com\/\d+\.js$/;
                    if (!scriptUrlPattern.test(value)) {
                        return "Please enter a valid script URL in the format: //js.hs-scripts.com/1234567.js";
                    }
                    return null;
                },
            },
        ],
    },
};

export default widgetModule;